import { styled } from '@mui/material';
import type { ITopProductPerformanceTableData } from 'src/queries/useTopProductPerformance';
import { lineClampStyles } from 'src/ui-components';

export const ProductCell = (data: ITopProductPerformanceTableData) => {
  return (
    <Wrapper>
      <Image $src={data.image} />
      <Text> {data.short_title}</Text>
    </Wrapper>
  );
};

const Wrapper = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

const Image = styled('div')<{ $src: string }>`
  width: 40px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid #e1e3da;
  background: url(${({ $src }) => $src}) lightgray 50% / cover no-repeat;
`;
const Text = styled('div')`
  ${lineClampStyles(2)};
  color: #121517;
  font-family: ${({ theme }) => theme.fonts.telka};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  flex: 1;
`;
